
// SVG Icon: questionmark
export default { id: "terriajs-questionmark" };
export const id = "terriajs-questionmark";
export const name = "questionmark";
